export const Tookan_status={
    "2":"Sucessful",
    "3":"Failed",
}